var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popconfirm',{attrs:{"confirm-button-text":"OK","cancel-button-text":"No,Thanks","icon":"el-icon-info","title":"Are you sure you want to delete this?"},on:{"confirm":_vm.deletefn}},[_c('div',{staticClass:"delete-button",attrs:{"slot":"reference"},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }